<template>
    <b-alert show :options="options" variant="danger" class="alert-cont">
        <error-icon class="icon-default error">
        </error-icon>
        <span class="message" v-html="message"></span>
    </b-alert>
</template>

<script>
import ErrorIcon from "../../assets/error.svg";
export default {
  name: "formalert",
  props: ["message", "options"],
  components: {
    ErrorIcon
  }
};
</script>

<style scoped>
.icon-default.error {
  width: 18px;
  height: 18px;
}
.alert-cont {
  display: flex;
      margin-left: 28px;
    margin-right: 28px;
}
.message {
  padding-left: 4px;
}
</style>
